export const MAX_WIDTH = 850;

export const PAYPAL_WIDTH = 1241;